export const SCALE_LIST = [25, 50, 100, 150, 200, 300, 400, 600, 800, 1000, 1500, 2000];
export const PROJECTS_LIMIT_BASIC = 2;
export const PROJECTS_LIMIT_HOBBY = 10;
export const SCREENS_LIMIT_BASIC = 3;
export const SCREENS_LIMIT_HOBBY = 10;
export const ASSETS_LIMIT_BASIC = 5;
export const ASSETS_LIMIT_HOBBY = 50;
export const SUBSCRIPTION_FAILED_STATES = ['expired', 'unpaid', 'past_due'];
export const PADDLE_CONFIG = {
    clientToken: 'live_6d9351b5eeca0d4a88201dd1747',
    prices: {
        hobby: {
            month: 'pri_01kjskbcb980gwq8sxan4bs3hm',
            annual: 'pri_01kjsmzc18pxdv67bvc6stzb7d',
        },
        plus: {
            week: 'pri_01kp63eqza1m15fahaxtwj0x9z',
            month: 'pri_01kjsn6pgc9kcqsv6x31x9xb9e',
            annual: 'pri_01kjsnekyc8td6jrm63kthzmaz',
            lifetime: 'pri_01m145pat5q4n620zp7xdav6d3',
        },
    },
};

export const DEV_PADDLE_CONFIG = {
    clientToken: `test_a92f2e7ce6431015ec55f403a1d`,
    prices: {
        hobby: {
            month: 'pri_01kjsn6pgc9kcqsv6x31x9xb9e',
            annual: 'pri_01kjsnekyc8td6jrm63kthzmaz',
        },
        plus: {
            month: 'pri_01kjsn6pgc9kcqsv6x31x9xb9e',
            annual: 'pri_01kjsnekyc8td6jrm63kthzmaz',
            lifetime: 'pri_01m145pat5q4n620zp7xdav6d3',
        },
    },
};
